import * as React from "react";
import { LucideIcon } from "lucide-react";
import { Button } from "./button";
import { cn } from "@/lib/utils";

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Icon to display. */
  icon: LucideIcon;
  /** Main title. */
  title: string;
  /** Supporting description text. */
  description: string;
  /** Optional action label. If provided, button shows. */
  actionLabel?: string;
  /** Action click handler. */
  onAction?: () => void;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex min-h-[200px] flex-col items-center justify-center text-center space-y-3",
        className
      )}
      {...props}
    >
      <Icon className="h-16 w-16 text-gray-500" aria-hidden />
      <div className="space-y-1">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-sm text-gray-500 max-w-md">{description}</p>
      </div>
      {actionLabel && (
        <Button onClick={onAction}>{actionLabel}</Button>
      )}
    </div>
  );
}
